/* Where to send a signed-out person so they land back on the page they asked for.
 *
 * SWA's `post_login_redirect_uri` takes a FULLY QUALIFIED URL (Microsoft Learn,
 * "Set up post-sign-in redirect"), so the origin is added here. The return
 * address is always this app's own origin, never anything taken from the URL.
 */
export function signInUrl({ origin, pathname = '/', search = '', hash = '' }) {
  const back = `${origin}${pathname}${search}${hash}`;
  return `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(back)}`;
}
